export default "__VITE_ASSET__DHRPCGA4__"